
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/other",
      function () {
        return require("private-next-pages/other/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/other"])
      });
    }
  